"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusFirstElement = void 0;
var React = require("react");
var FocusFirstElement = function (_a) {
    var children = _a.children;
    var element = React.createRef();
    var focusFirstElement = function () {
        var firstFocus = element.current.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        var focusElementArray = Array.prototype.slice.call(firstFocus);
        var firstElement = focusElementArray[0];
        if (firstElement) {
            firstElement.focus();
        }
    };
    React.useEffect(function () {
        focusFirstElement();
    }, []);
    return React.createElement("div", { ref: element }, children);
};
exports.FocusFirstElement = FocusFirstElement;
